module.exports = __webpack_public_path__ + "img/ic_tutorial.065bc647.svg";